(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-payment-method-strip"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.getElementById('HCPaymentMethodStrip');
    if (!template) return;

    const selectors = ['.hc-cart-checkout', '.hc-cart-drawer__checkout'];

    const mount = () => {
      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((checkout) => {
          const next = checkout.nextElementSibling;
          if (next && next.classList.contains('hc-payment-strip')) return;
          checkout.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
        });
      });
    };

    mount();
    document.addEventListener('shopify:section:load', mount);
    new MutationObserver(mount).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
